export const BASE_CLASS_NAME: string = 'ui-bottom-sheet';

export const OVERLAY_CLASS_NAME: string = `${BASE_CLASS_NAME}-overlay`;
